import React, { useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import images from "../../../assets/images";
import Modal from "../../../components/modal/Modal";
import { usePremisesStore } from "../../../store/store";
import { isDefined } from "../../../common/utils";
import { DotLoader } from "../../../components/loader/Loader";
import { usePermissions } from "../../../hooks/usePermission";
import { useNavigate } from "react-router-dom";
import CreateHazardAndVulnerability from "./CreateHazardAndVulnerability";
ModuleRegistry.registerModules([AllCommunityModule]);
const gridTheme = themeQuartz.withParams({
  accentColor: "#93AA9A",
  headerHeight: "200px",
  browserColorScheme: "light",
  headerFontSize: 14,
});
const HazardAndVulnerabilityAssessment: React.FC = () => {
  const { canCreate, canRead, canUpdate } = usePermissions();
  const [rowData, setRowData] = useState<any[]>([]);
  const [isCreating, setIsCreating] = useState<boolean>(false);
  const navigate = useNavigate();
  const [loadingRisks, setLoadingRisks] = useState<boolean>(false);
  const defaultColDef = useMemo(
    () => ({
      wrapText: true,
      headerClass: "font-bold text-md bg-gray-100 p-2",
    }),
    []
  );

  const gridTheme = themeQuartz.withParams({
    accentColor: "#93AA9A",
    headerHeight: "200px",
    browserColorScheme: "light",
    headerFontSize: 14,
  });
  const [columnDefs, setColDefs] = useState<any>([
    {
      field: "AddressOfPremises",
      headerName: "Address of Premises",
      sortable: false,
      headerClass: "ag-center-header",
      headerStyle: { backgroundColor: "#e9f5ff" },
      flex: 1.5,
      cellStyle: { textAlign: "center", padding: "10px" },
    },
    {
      field: "action",
      headerClass: "ag-center-header",
      headerName: "Action",
      cellStyle: { padding: "10px" },
      headerStyle: { backgroundColor: "#e9f5ff" },
      flex: 0.8,
      cellRenderer: (params: any) => (
        <div className="flex gap-x-3 justify-center">
          {canRead("hazard-and-vulnerability-assessment") && (
            <button className="p-1 hover:bg-gray-100 rounded-full transition-colors">
              <img className="w-5 h-5" src={images.viewIcon} alt="View" />
            </button>
          )}
          {canUpdate("hazard-and-vulnerability-assessment") && (
            <button className="p-1 hover:bg-gray-100 rounded-full transition-colors">
              <img className="w-5 h-5" src={images.editIcon} alt="Edit" />
            </button>
          )}
        </div>
      ),
      filter: false,
    },
  ]);
  const theme = useMemo(() => {
    return gridTheme;
  }, []);
  return (
    <div className="px-2 py-4 mt-14 w-full h-full">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-semibold text-gray-900 mb-4">
            Hazard and Vulnerability Assessment
          </h1>
          <button
            className="flex btn-primary roundedBt iconWithBt text-uppercase mr-4 mb-4"
            onClick={() => {
              setIsCreating(true);
              navigate(
                "/external-emergency-preparedness/hazard-and-vulnerability-assessment"
              );
            }}
          >
            <img src={images.addPremiessIcon} alt="" />
            <span> CREATE HAZARD AND VULNERABILITY ASSESSMENT</span>
          </button>
        </div>

        <div className="ag-theme-alpine w-full h-[750px] pl-2 border-0 rounded-lg shadow-lg">
          {!loadingRisks ? (
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              theme={theme}
              headerHeight={65}
              rowHeight={100}
              defaultColDef={defaultColDef}
            />
          ) : (
            <DotLoader />
          )}
        </div>
      </div>
      <Modal
        isOpen={isCreating}
        onClose={() => setIsCreating(false)}
        modalClass={"w-full relative risk-modal-close"}
      >
        <CreateHazardAndVulnerability onClose={() => setIsCreating(false)} />
      </Modal>
    </div>
  );
};

export default HazardAndVulnerabilityAssessment;
